export default __webpack_public_path__ + "static/media/tick.a830ac2f.mp3";